import { Box, Typography } from "@mui/material";
import React from "react";

interface IDetailItemProps {
  label: string;
  value: string | number;
  maxWidth?: number;
}

const DetailItem = ({ label, value, maxWidth }: IDetailItemProps) => {
  return (
    <Box className="flex flex-col gap-1">
      <Typography fontSize={14} color="gray.darker">
        {label}
      </Typography>
      <Typography fontSize={16} maxWidth={maxWidth}>
        {value}
      </Typography>
    </Box>
  );
};

export default DetailItem;
